import { useQuery } from "@tanstack/react-query";
import Image from "next/image";

import { getMediaListByIds, isVideo } from "../../core/media.core";
import CloseIcon from "../../icons/iconClose.comp";
import LoadingOvalIcon from "../../icons/loadingOval.icon";

export default function MediaListTiny({
  ids,
  handleDelete,
  displayId = "media-list",
}: {
  ids: string[];
  handleDelete: (id: string) => void;
  displayId?: string;
}) {
  const isEmpty = !ids || ids.length === 0;

  const {
    data: mediaList,
    isFetched,
    isError,
  } = useQuery({
    queryKey: ["mediaListbyIds", ids],
    queryFn: (context) => getMediaListByIds(context.queryKey[1] as string[]),
    enabled: !isEmpty,
  });

  if (isError) return <div>Error...</div>;
  if (!isFetched && !isEmpty) return <LoadingOvalIcon />;

  if (!mediaList || mediaList?.length < 1) return null;

  return (
    <div className="flex gap-2 tiny-gallery overflow-x-hidden py-2" id={displayId}>
      {mediaList.map((media) => {
        if (!media) return null;

        return (
          <div className="relative" key={media.id}>
            <CloseIcon
              className="w-3 h-3 -right-1 absolute -top-1 bg-red-400 text-white rounded-lg cursor-pointer"
              onClick={() => handleDelete(media.id)}
            />
            {!isVideo(media) && (
              <Image
                unoptimized
                className="border-2"
                alt={media.filename}
                key={media.filename}
                src={media.thumbnailUrl}
                width={100}
                height={100}
              />
            )}
            {isVideo(media) && <video src={media.url} width={100} height={100} />}
          </div>
        );
      })}
    </div>
  );
}
